import {observer} from "mobx-react"
import {App} from "./App"
import {UserCreatePage, UserDetailPage, UserOverviewPage} from "../page/ums";
import {UserConfigurationPage} from "../page/ums/UserConfigurationPage";

type AppMode = 'overview' | 'create' | 'detail' | 'config'

const UmsApp = observer(function UmsApp({mode}: {mode: AppMode}) {
    return <App>
        {mode === 'overview' && <UserOverviewPage />}
        {mode === 'detail' && <UserDetailPage />}
        {mode === 'create' && <UserCreatePage />}
        {mode === 'config' && <UserConfigurationPage />}

    </App>
})

export {
    UmsApp
}
